// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"e76bba14","227":"9d1c85f1","453":"39e18f3c","982":"440ac15b"}[chunkId] + ".chunk.js";
};